module.exports = __webpack_public_path__ + "img/sports-motorsports.b891724f.svg";